import App from './App';
import Button from './Button';
import Game from './Game';
import Login from './Login';

export {
  App,
  Button,
  Game,
  Login,
}



// WEBPACK FOOTER //
// ./src/components/index.js